(function(app) {

    app.provider("prosperaSalesForceApi",
    [
        function() {
            this.$get = [
                "complianceHubApiGateway", function(complianceHubApiGateway) {
                    var service = {};                 

                    service.lookupAdvisorClientsSf = function () {
                        return complianceHubApiGateway.get("/Prospera/SalesForce/LookupAdvisorClients");
                    };

                    service.lookupAdvisorSf = function (advisorAccountNumber) {
                        return complianceHubApiGateway.get("/Prospera/SalesForce/LookupAdvisor/" + advisorAccountNumber);
                    };

                                        
                    service.lookupClientSf = function (clientAccountId) {
                        return complianceHubApiGateway.get("/Prospera/SalesForce/LookupClient/" + clientAccountId);
                    };                 

                    return service;
                }
            ];
        }
    ]);
})(window.app);